// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607170519/js/" + chunkId + "." + {"44":"c3fd799f","225":"9ad88699","481":"d0b37832","486":"87de4c35","770":"07ce3484"}[chunkId] + ".0.9945616176453579.chunk.js";
};